export default {
    data() {
        return {
            defaultColumns: [
                {
                    code: 'due_date',
                    label: this.$l10n.__('Date'),
                    sortKey: 'date',
                    order: 0,
                    isVisible: true,
                    isMovable: false,
                    isDefault: true,
                },
                {
                    code: 'type',
                    label: this.$l10n.__('Type'),
                    sortKey: 'event',
                    order: 1,
                    isVisible: true,
                    isMovable: false,
                    isDefault: true,
                },
                {
                    code: 'priority',
                    label: this.$l10n.__('Priorité'),
                    sortKey: 'priority',
                    order: 2,
                    isVisible: true,
                    isMovable: true,
                },
                {
                    code: 'label',
                    label: this.$l10n.__('Label'),
                    sortKey: 'label',
                    order: 3,
                    isVisible: true,
                    isMovable: true,
                },
                {
                    code: 'related',
                    label: this.$l10n.__('Liaisons'),
                    order: 4,
                    isVisible: true,
                    isMovable: true,
                },
                {
                    code: 'description',
                    label: this.$t.__('common.labels.description'),
                    order: 5,
                    isVisible: false,
                    isMovable: true,
                },
                {
                    code: 'title',
                    label: this.$l10n.__('Titre'),
                    order: 6,
                    isVisible: true,
                    isMovable: true,
                },
                {
                    code: 'staff',
                    label: this.$l10n.__('Collaborateur(s)'),
                    order: 7,
                    isVisible: true,
                    isMovable: true,
                },
            ],
        };
    },
};
